<template>
  <el-dialog
    title="圆通客户管家充值协议"
    :visible.sync="dialogVisible"
    width="800px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <div class="createOrderPrivacy">
      <div style="max-height:400px;overflow-y: auto;">
        <div class="title">【重要修订提示】</div>
        <div class="sub-title-line">本协议本次修订核心变更为：自2026年10月22日起，对圆通客户管家特惠寄服务结算规则作出如下调整：一、调整结算与扣费规则（结算周期及结算重量）；二、新增自动退费、自动取消及拦截更址计费规则。本次修订对用户权益有重大影响的内容，均已通过加粗方式履行重点提示义务，您继续使用本平台服务的，即视为已充分阅读、理解并自愿接受本次全部修订内容。</div>
        <div class="title">【提示条款】</div>
        <div class="sub-title-line">本协议是您（以下称“用户”或您）与圆通速递股份有限公司（以下简称“圆通”）关于使用圆通客户管家平台进行运费预充值，及使用逆向退货寄、小B商家寄服务订立的协议。</div>
        <div class="sub-title-line">为保障您的合法权益，请在接受本协议前仔细阅读并充分理解所有条款，包括但不限于责任划分、服务规则、费用约定及圆通速递已发布或未来可能发布的各类平台规则、通知、公告、声明和风险提示等。</div>
        <div class="sub-title-line">您知悉并同意：只有在不加修改地完全接受本协议全部内容，且严格遵守互联网及圆通客户管家平台相关法律、法规与规则的前提下，方可使用本平台提供的服务；如您不同意本协议任何条款，或无法准确理解条款含义，请不要进行后续操作。</div>
        <div class="sub-title-line">若您点击 “我已阅读并同意”，或通过其他任何方式实际使用本平台服务，即视为您已充分理解并完全接受本协议及相关规则的全部内容。此后，您不得以未阅读本协议为由提出任何形式的抗辩。</div>
        
        <div class="content">
          <div class="title">1、定义</div>

          <dt class="cont">1.1圆通速递股份有限公司，系指依法设立、取得快递业务经营许可证，拥有“圆通”“yto”注册商标，从事快递业务的股份有限公司，为本协议项下客户管家平台的运营主体，负责运费预充值及相关服务的管理与结算。</dt>
          <dt class="cont">1.2圆通速递网点，是指依法设立，经圆通授权使用“圆通”“yto”注册商标，从事快递业务，自主承担快递服务法律责任的企业法人，是本协议项下实际提供寄件服务的单位。</dt>
          <dt class="cont">1.3用户，是指注册、登录、使用圆通客户管家进行运费预充值及/或使用逆向退货寄、小B商家寄服务的单位或个人。</dt>
          <dt class="cont">1.4圆通客户管家平台，系指圆通为用户提供的运费预充值、订单管理、费用对账等一体化服务的网站或移动应用程序。</dt>
          <dt class="cont">1.5运费预充值，系指用户通过圆通客户管家平台预先充值资金至个人账户，该资金仅可用于支付逆向退货寄、小B商家寄服务产生的运费及相关服务费，不可用于其他用途，不计息、未使用余额可按本协议约定提现。</dt>

          <dt class="cont">1.6逆向退货寄服务，系指用户通过平台发起的消费者退货场景寄件服务，预充值运费后，平台按包裹数量、重量、运输距离等从预充值账户中扣除运费（定价详情见下单界面）。</dt>
          <dt class="cont">1.7小B商家寄服务，系指小型商业主体通过平台发起的批量寄件服务，预充值运费后，平台按当日寄件数量、重量。收发地址等阶梯价扣除运费（定价详情见下单界面）。</dt>
          <dt class="cont">1.8运费预冻结：指用户下单时，平台根据对应服务的1公斤基础运费标准，从预充值账户中临时冻结资金，待包裹揽收并确认重量后，按实际费用多退少补的机制。</dt>
          <dt class="cont">1.9结算重量：优先取大网结算重量；大网无结算重量时，取“揽收重量”与“中心下车重量（称重和体积重取其重）”中的较大值；均无记录的，以取件登记重量兜底。</dt>

          <div class="title">2、协议内容及变更</div>
          
          <dt class="cont">2.1本协议内容包括协议正文、附件及所有圆通已发布或将来可能发布的平台规则（特别是关于运费预充值的规则）。所有附件及平台规则均为本协议不可分割的组成部分，与协议正文具有同等法律效力。若协议正文、附件与平台规则存在冲突，以发布时间在后的文件为准执行。</dt>
          <dt class="cont">2.2圆通可能会不时更新本协议内容，您可在圆通客户管家软件内页或官方网站查阅最新版协议条款。更新后的协议条款一经公布，即取代原条款。协议更新后，如您不同意接受，应停止使用圆通客户管家提供的服务。</dt>
          <dt class="cont">2.3因市场行情波动、运营成本变动、国家政策调整等客观因素，圆通有权对本协议项下寄递服务运价、阶梯计价标准进行调整。运价调整将提前7个自然日通过客户管家平台首页公告、平台站内信方式向用户进行公示通知。调价生效前已完成提交的订单，仍按照调整前价格执行；调价生效后新产生订单适用调整后价格。</dt>
          <dt class="cont">若用户不接受调价方案，有权停止使用本平台寄递服务，并可按照本协议约定申请对账户内未消费的预充值余额办理提现，圆通不会就此向用户收取违约金。公示期届满后，用户继续在平台下单使用寄递服务的，视为同意接受调整后的价格标准。</dt>

          <div class="title">3、开通与使用</div>
          
          <dt class="cont">3.1用户资格</dt>
          <dt class="cont">您确认，您具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述民事行为能力，您及您的监护人应依照法律规定承担由此产生的一切后果。</dt>


          <dt class="cont">3.2信息管理</dt>
          <dt class="cont">3.2.1使用圆通客户管家平台时，您应按照系统提示准确、完整地提供信息（包括但不限于联系电话、电子邮箱、地址等）。如信息发生变更，应及时更新为最新、真实、完整的信息，以便圆通或相关方与您联系。</dt>
          <dt class="cont">3.2.2您理解并同意，有义务保持所提供信息的真实性和有效性。如圆通按您提供的信息无法联系到您、您未按要求及时提供信息，或信息不实、失效的，圆通将按平台规则处理，您应承担因此给自身、他人及圆通造成的全部损失与不利后果。</dt>
          
          <dt class="cont">3.3账户安全</dt>
          <dt class="cont">3.3.1您的账户（包括账户名、密码、支付密码等）由您自行设置并保管，圆通不会主动要求您提供账户信息，请务必妥善保管。因您主动泄露、保管不当导致泄露，或因他人攻击、诈骗等行为造成的损失及后果，圆通不承担责任。</dt>
          <dt class="cont">3.3.2您应对账户项下的所有行为结果（包括但不限于在线签署协议、运费预充值、支付运费等）负责。</dt>
          <dt class="cont">3.3.3如发现账户未经授权使用或可能遭窃、遗失的情况，建议您立即通知圆通，并授权圆通将该信息同步给其关联公司或合作方。您理解圆通对您的请求采取行动需要合理时间，除圆通存在过错外，圆通对采取行动前已产生的后果不承担责任。</dt>

           <dt class="cont">3.4账户权限</dt>
           <dt class="cont">如您用于登录圆通客户管家平台的账户暂时或永久无法使用，您可能无法使用平台服务（包括运费预充值），直至账户恢复正常。</dt>

           <div class="title">4、圆通客户管家平台服务及规范</div>
           <dt class="cont">4.1运费预充值服务</dt>
           <dt class="cont">4.1.1预充值方式：用户可通过圆通客户管家平台支持的在线支付渠道（如银行卡、第三方支付工具等）进行运费预充值，不支持现金充值。预充值金额实时到账，用户可在“账户管理-预充值记录”中查看明细。</dt>
           <dt class="cont">4.1.2实名验证：当用户进行预充值时，应按照平台提示完成实名验证，提供有效身份证件（自然人：居民身份证、护照等；法人：营业执照、统一社会信用代码证等），未完成实名验证的用户将无法继续充值。</dt>
           <dt class="cont">4.1.3预充值资金用途：预充值资金仅可用于支付逆向退货寄、小B商家寄服务的运费及相关服务费，不可用于其他快递服务或非快递类消费，不可转赠、转借他人使用。</dt>
           <dt class="cont">4.1.4发票规则：用户可凭平台内实际消费记录申请开具等额发票，具体开票流程及要求以平台指引为准，充值费用不可申请开票。</dt>
           <dt class="cont">4.1.5充值手续费：用户通过平台进行运费预充值时，产生的支付渠道手续费由圆通承担，用户无需额外支付。</dt>
           <dt class="cont">4.1.6预冻结规则：用户下单时，平台按对应服务的1公斤基础运费标准预冻结资金（如逆向退货寄1公斤基础运费5元，下单即冻结5元）；实际费用确认后，冻结资金自动调整为实际金额，多冻结部分实时解冻。</dt>

           <dt class="cont">4.2结算与扣费</dt>
           <dt class="cont">4.2.1结算周期：运单完成签收（以正常签收为准）的次日起，系统根据结算重量计算实际运费，并从预充值账户中扣除；无签收记录的运单不予结算。</dt>
           <dt class="cont">4.2.2对账功能：用户可在“特惠寄件-特惠寄账单”查看实时扣费记录、月度汇总报表（含每单重量、费用明细），支持导出Excel对账。</dt>
           <dt class="cont">4.2.3自动退费：用户订单自生成之日起15日内无取件及之后轨迹，或取件（揽收）后无其他轨迹，圆通有权自动发起拦截取消订单并退费；拦截扫描、始发端退回不计入操作轨迹。</dt>
           <dt class="cont">4.2.4拦截更址计费：订单地址发生变更的，无首中心操作记录的，按最新地址结算并多退少补；有首中心操作记录的，按最新地址结算，少补但多不退。</dt>

           <dt class="cont">4.3 提现规则</dt>
           <dt class="cont">4.3.1用户申请提现预充值资金的，需满足以下条件：</dt>
           <dt class="cont">（1）已完成实名验证；</dt>
           <dt class="cont">（2）未使用预充值资金或仅部分使用（仅退还未使用部分）；</dt>

           <dt class="cont">4.3.2 提现流程：用户通过客户管家申请提现，平台将先冻结未结算运费，您仅可提现未冻结部分；待运费全部结算后，剩余解冻余额可再次提现。</dt>
           <dt class="cont">自【2026 年 4 月 15 日】起，原 “提现手续费暂由圆通承担，用户无需承担” 的约定正式终止执行，用户使用提现服务需按本条款约定支付提现手续费，具体规则如下：计费标准：按用户单笔提现申请金额的【0.3%】计提，单笔提现手续费最低收取【0.01】元，（根据实际提现金额计算，四舍五入取整，不满0.01元不收取）；</dt>
           <dt class="cont">收取方式：手续费于用户发起提现申请时实时计算，直接从该笔提现申请的本金中扣除，扣除手续费后的剩余资金划转至用户指定的本人实名认证支付宝账户；用户发起提现申请，即视为同意授权平台按前述规则划扣对应提现手续费；</dt>
           <dt class="cont">费用说明：本提现手续费用于覆盖平台向支付机构支付的渠道手续费、资金清结算技术服务成本、提现服务运营成本等相关费用。</dt>

           <dt class="cont">4.3.3 开票：用户可通过客户管家对已结算的运单申请开票。预充值运费因未产生实际交易，暂不支持开票；待实际寄件扣除运费后，可就实际扣除金额申请开票。</dt>
           <dt class="cont">4.3.4 规则调整与特殊情形处理</dt>
           <dt class="cont">规则调整：平台有权根据国家法律法规、监管政策、支付渠道费率变动及业务运营情况，对本条款项下的提现手续费计费标准、收取方式等规则进行调整。调整将至少提前 7 个自然日，通过平台官网公告、站内信、系统弹窗、协议更新等一种或多种方式向用户公示；公示期满后，调整后的规则即生效。若用户不接受调整后的规则，应停止使用提现服务；用户继续使用提现服务的，视为已充分阅读、理解并接受调整后的全部规则。</dt>
           <dt class="cont">提现失败处理：因用户提供的支付宝账户信息错误、账户状态异常（挂失、冻结、注销等）、未完成实名认证等非平台原因，导致提现申请失败、资金退回的，已计提的手续费将全额退回至用户平台储值钱包账户；因平台系统故障、操作失误导致提现失败的，平台除全额退回手续费及提现本金外，不承担额外违约责任。</dt>
           <dt class="cont">到账说明：资金到账时间以支付宝支付渠道的处理时效为准，平台不承诺资金到账时限，仅负责向支付机构推送合规的提现指令；因银行、支付机构系统维护、监管核查等不可抗力因素导致到账延迟的，平台不承担相关责任。</dt>

           <dt class="title">5、用户的违约及处理</dt>
           <dt class="cont">5.1如用户实施下列行为之一，圆通及其关联公司有权按5.2条约定处理：</dt>           
           <dt class="cont">（1）将预充值资金用于本协议约定外的用途（如套现、购买其他商品）；</dt>           
           <dt class="cont">（2）转卖、转借预充值资金或服务资格给他人牟利；</dt>           
           <dt class="cont">（3）通过非正规方式获取预充值优惠；</dt>           
           <dt class="cont">（4）盗用他人账户进行运费预充值；</dt>           
           <dt class="cont">（5）利用平台服务从事违法活动。</dt>    
           
           <dt class="cont">5.2圆通及其关联公司有权根据情节严重程度，在不通知用户的情况下采取以下一项或多项措施，且无需补偿或退费，由此产生的责任由用户自行承担；给圆通或第三方造成损失的，用户应全额赔偿（包括赔偿金、诉讼费、律师费等）：</dt>
           <dt class="cont">（1）暂停或终止提供全部或部分平台服务（包括充值）；</dt>           
           <dt class="cont">（2）永久封禁用户账户及预充值权限；</dt>           
           <dt class="cont">（3）冻结或清空账户内全部或部分预充值余额；</dt>           
           <dt class="cont">（4）追回已使用的违规资金。</dt>  

           <dt class="title">6、争议处理</dt>  
           <dt class="cont">6.1您与其他用户或圆通在使用平台过程中发生争议的，应优先友好协商解决；协商不成的，可申请圆通介入调处，或向圆通住所地人民法院提起诉讼。</dt>           
           <dt class="cont">6.2圆通作为调处方，将根据调查的事实及平台规则作出调处决定，用户应先行履行；对调处决定不服的，可通过诉讼解决。</dt> 


          <dt class="title">7、责任限制</dt>               
          <dt class="cont">7.1圆通按“现状”提供平台服务，对因下列原因导致的损失不承担责任：</dt> 
          <dt class="cont">（1）信息网络设备维护、系统故障、电力中断等导致服务暂停；</dt> 
          <dt class="cont">（2）不可抗力（如地震、洪水、战争）导致服务无法提供；</dt> 
          <dt class="cont">（3）第三方原因（如支付渠道故障、黑客攻击）导致的问题。</dt> 

          <dt class="cont">7.2您使用第三方提供的与平台相关的服务（如支付工具）时，应自行与第三方约定权利义务，圆通不对您与第三方的纠纷承担责任。</dt> 

          <dt class="title">8、协议的终止</dt>               
          <dt class="cont">8.1终止情形：</dt> 
          <dt class="cont">（1）协议任何一方提前15日书面通知对方解除；</dt> 
          <dt class="cont">（2）用户违反本协议约定，圆通有权立即解除；</dt> 
          <dt class="cont">（3）用户连续180天未登录且无预充值余额的，圆通可解除协议；</dt>           
          <dt class="cont">（4）法律规定的其他情形。</dt>       
          <dt class="cont">8.2终止后事项：</dt> 
          <dt class="cont">（1）协议终止后，用户无法继续使用平台服务，圆通关闭账户权限；</dt> 
          <dt class="cont">（2）圆通有权保留用户注册信息及交易记录（法律规定期限内），但无义务提供数据查询；</dt> 
          <dt class="cont">（3）终止前的违约行为，圆通仍可追究责任；有未使用预充值余额的，按本协议4.3条提现规则处理。</dt>    

          <dt class="title">9、用户信息保护</dt>  
          <dt class="cont">9.1圆通及分支机构可收集、存储、使用用户及寄件人、收件人的信息（用于物流服务、合规管理），并按照法律法规及平台隐私政策保护信息安全。</dt> 
          <dt class="cont">9.2您使用平台服务即同意圆通按本协议及隐私政策处理您的信息，包括向监管部门提供必要信息。</dt> 

          <dt class="title">10、法律适用与管辖</dt>  
          <dt class="cont">10.1本协议适用中华人民共和国法律（不含港澳台地区法律）。</dt> 
          <dt class="cont">10.2因本协议产生的争议，协商不成的，任何一方可向圆通速递股份有限公司住所地人民法院提起诉讼。</dt>          
          
          <dt class="title">11、其他</dt>  
          <dt class="cont">11.1如本协议任何条款被认定为无效或不可执行，不影响其他条款的效力。</dt> 

        </div>
      </div>
      <div class="y-t-ac y-mt-20">
         <el-checkbox v-model="isChecked">我已阅读，同意以上协议</el-checkbox>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="confirmFn">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: "reChargePrivacy",
  props: ["isShow"],
  data() {
    return {
      dialogVisible: this.isShow,
      isChecked: false,
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
  },  
  created() {
    // let privacy = localStorage.getItem('checkedReturnChargePrivacy'+this.userMess.loginId);
    // this.isChecked = privacy == 'Y';
  },
  methods: {
    confirmFn() {
      if (!this.isChecked) {
        this.$message.error('请勾选阅读协议');
        return false;
      } 
      // localStorage.setItem('checkedReturnChargePrivacy'+this.userMess.loginId, 'Y');
      this.handleClose('refresh');
    },
    handleClose(refresh) {
      this.dialogVisible = false;
      this.$emit('close', refresh== 'refresh' ? this.isChecked : false);
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.createOrderPrivacy {
  line-height: 24px;
  .title {
    color: #000;
    font-size: 14px;
    font-weight: bold;
    line-height: 28px;
  }
  .indent {
    text-indent: 14px;
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
  padding-top: 0;
}
</style>